// Couleur d'accent par rôle, utilisée par les headers de drawer (DrawerHeader.jsx).
// Les mêmes hex sont encore recopiés en dur dans une quinzaine d'autres composants
// (filtres, boutons, tableaux) : les faire passer par ici est un chantier à part.
export const ROLE_ACCENT = {
  onet: "#06305C",
  compass: "#C4AC66",
};

// admin / rôle inconnu : jaune de marque, lu depuis le thème plutôt qu'en dur.
export const getRoleAccent = (role, theme) =>
  ROLE_ACCENT[role] ?? theme.palette.primary.main;
